export const API_URL = process.env.REACT_APP_API_URL;

export const IS_PRODUCTION = true || process.env.REACT_APP_ENV === "production";

export const AUTH0 = {
    DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
    CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID,
    AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
}